import {
  localFormatter,
  elementPositioner
} from './utils/functions.js';
const ApiService = require('./utils/ApiService');
const Vue = window.Vue;

Vue.component('Scroller', {

  delimiters: ['${', '}'],
  props: {
    template: {
      type: String,
      default: '#vue-infin-scroller-template'
    },
    page: {
      type: Number,
      default: 1
    },
    itemsperpage: {
      type: Number,
      required: true
    },
    query: {
      type: String,
      default: ''
    },
    itemClasses: {
      type: String,
      default: 'col-12 col-sm-6 col-md-4 col-lg-3'
    },
    pagelimit: {
      type: [String, Number]
    },
    categoryid: [Number],
    tagid: [String, Number]
  },

  data: function () {
    return {
      list: [],
      topPageCount: 1,
      bottomPageCount: 1,
      pageMax: 0,
      bottomLoaderVisible: true,
      topLoaderVisible: false,
      buttonVisibility: false,
      topBufferIndex: 0,
      buttonSpinerVisibility: false,
      topObserver: null,
      bottomObserver: null,
      topIntersecting: false,
      bottomIntersecting: false
    };
  },

  mounted () {
    this.topObserver = new IntersectionObserver(([entry]) => {
      this.topIntersecting = entry && entry.isIntersecting;
    }, {});
    this.topObserver.observe(this.$el.querySelector('.top-shadow-element'));

    this.bottomObserver = new IntersectionObserver(([entry]) => {
      this.bottomIntersecting = entry && entry.isIntersecting;
    }, {});
    this.bottomObserver.observe(this.$el.querySelector('.bottom-shadow-element'));
  },

  destroyed () {
    this.topObserver.disconnect();
    this.bottomObserver.disconnect();
  },

  created () {
    const localData = localFormatter();

    if (this.categorySearch() == localData.currentCategory && this.itemsperpage == localData.itemsPerPage && document.location.search == localData.filterParam) {
      this.topPageCount = localData.pageCount;
      this.bottomPageCount = localData.pageCount;
      this.topBufferIndex = localData.itemId;
      this.startRequest(localData.pageCount, localData.itemId);
    } else {
      localStorage.removeItem('pageCount');
      localStorage.removeItem('itemId');
      localStorage.removeItem('currentCategory');
      localStorage.removeItem('itemsPerPage');
      localStorage.removeItem('filterParam');
      this.topPageCount = 1;
      this.bottomPageCount = 1;
      this.startRequest(1, false);
    }

    let scrollTimeout;

    $(window).on('scroll', () => {
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(() => {
          if (!this.topLoaderVisible && this.topIntersecting) {
            this.infiniteHandlerTop();
          }
          if (!this.bottomLoaderVisible && this.bottomIntersecting) {
            this.infiniteHandlerBottom();
          }
          scrollTimeout = null;
        }, 50);
      }
    });
  },

  methods: {
    getItemClasses () {
      const classes = {};

      this.itemClasses.split(' ').forEach(function (item) {
        if (item.length > 0) {
          classes[item] = true;
        }
      });

      return classes;
    },

    request (pageCount) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', pageCount);
      url.searchParams.set('inf', 1);

      return ApiService.get(url.toString());
    },

    categorySearch () {
      if (this.categoryid != undefined) {
        return this.categoryid;
      }
      if (this.query != '') {
        return this.query;
      }
      if (this.tagid != undefined) {
        return this.tagid;
      }
    },

    buttonFunc () {
      this.buttonVisibility = false;
      this.bottomPageCount++;
      if (this.bottomPageCount > this.pageMax) {
        this.buttonSpinerVisibility = false;
        return false;
      }

      this.request(this.bottomPageCount).done(data => {
        if (data && data.options) {
          this.list = this.list.concat(this.arrayProcessor(data, this.bottomPageCount));
        }
        this.buttonVisibility = true;
      });
    },

    itemClick (pageCount, itemId) {
      localStorage.setItem('pageCount', pageCount);
      localStorage.setItem('itemId', itemId);
      localStorage.setItem('currentCategory', this.categorySearch());
      localStorage.setItem('itemsPerPage', this.itemsperpage);
      localStorage.setItem('filterParam', document.location.search);
    },

    startRequest (pageCount, itemId) {
      this.bottomLoaderVisible = true;
      this.request(pageCount).done(data => {
        this.pageMax = data.options.pageMax;
        this.list = this.list.concat(this.arrayProcessor(data, pageCount));
        this.bottomLoaderVisible = false;
        this.$nextTick(() => {
          if (itemId) {
            elementPositioner('[item-id="' + itemId + '"]');
          }
          if (pageCount != 1) {
            this.topPageCount--;
            this.topLoaderVisible = true;
            this.request(pageCount - 1).done(data => {
              this.topBufferIndex = data.entries[0].data.variation.id;
              this.list = this.arrayProcessor(data, pageCount - 1).concat(this.list);
              this.topLoaderVisible = false;
              this.$nextTick(() => {
                if (itemId) {
                  elementPositioner('[item-id="' + itemId + '"]');
                }
              });
            }).fail(() => {
              this.topLoaderVisible = false;
            });
          }

          if (pageCount != data.options.pageMax) {
            if (localStorage.pageCount) {
              this.bottomPageCount++;
              this.bottomLoaderVisible = true;
              this.request(this.bottomPageCount).done(data => {
                this.list = this.list.concat(this.arrayProcessor(data, this.bottomPageCount));
                this.bottomLoaderVisible = false;
                this.$nextTick(() => {
                  if (itemId) {
                    elementPositioner('[item-id="' + itemId + '"]');
                  }
                });
              }).fail(() => {
                this.bottomLoaderVisible = false;
              });
            } else {
              this.bottomLoaderVisible = false;
            }
          }
        });
      });
    },

    infiniteHandlerBottom () {
      this.bottomPageCount++;
      if (this.bottomPageCount > this.pageMax) {
        return false;
      }

      if (this.bottomPageCount <= this.pagelimit) {
        this.bottomLoaderVisible = true;
        this.request(this.bottomPageCount).done(data => {
          if (data && data.options) {
            this.list = this.list.concat(this.arrayProcessor(data, this.bottomPageCount));
          }
          this.bottomLoaderVisible = false;
        }).fail(() => {
          this.bottomLoaderVisible = false;
        });
      } else {
        this.bottomPageCount--;
        this.buttonVisibility = true;
        this.buttonSpinerVisibility = true;
      }
    },

    infiniteHandlerTop () {
      this.topPageCount--;
      if (this.topPageCount <= 0) {
        return false;
      }

      this.topLoaderVisible = true;
      this.request(this.topPageCount).done(data => {
        if (data && data.options) {
          this.list = this.arrayProcessor(data, this.topPageCount).concat(this.list);
          this.topLoaderVisible = false;
          this.$nextTick(() => {
            elementPositioner('[item-id="' + this.topBufferIndex + '"]');
            this.topBufferIndex = data.entries[0].data.variation.id;
          });
        }
      }).fail(() => {
        this.topLoaderVisible = false;
      });
    },

    arrayProcessor (data, pageCount) {
      const bufferArray = [];

      data.entries.filter(element => !this.list.some(item => item.data.variation.id === element.data.variation.id)).forEach(element => {
        bufferArray.push({ ...element, pageCount: pageCount });
      });
      return bufferArray;
    }
  }
});
